import { render, staticRenderFns } from "./EliteligaTopWidget.vue?vue&type=template&id=195c19ad&"
import script from "./EliteligaTopWidget.vue?vue&type=script&lang=ts&"
export * from "./EliteligaTopWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports